/**
 * Génération du PDF du relevé étudiant.
 * Utilise html2canvas pour capturer le DOM et jspdf pour produire le PDF.
 */
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export async function genererPdfReleve(
  element: HTMLElement,
  filename: string = 'releve.pdf',
): Promise<void> {
  // Force light theme pour la capture (lisibilité du PDF)
  const wasDark = document.documentElement.classList.contains('dark');
  if (wasDark) document.documentElement.classList.remove('dark');

  try {
    const canvas = await html2canvas(element, {
      scale: 2,
      backgroundColor: '#ffffff',
      useCORS: true,
      logging: false,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
    });

    const imgData = canvas.toDataURL('image/png');

    // Calcul des dimensions A4 portrait (mm)
    const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 8;

    const imgWidth = pageWidth - 2 * margin;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightRemaining = imgHeight;
    let position = margin;

    // Si l'image dépasse une page, paginer
    if (imgHeight <= pageHeight - 2 * margin) {
      pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
    } else {
      // Découper en pages
      const pageContentHeight = pageHeight - 2 * margin;
      let currentY = 0;
      while (heightRemaining > 0) {
        pdf.addImage(
          imgData,
          'PNG',
          margin,
          position - currentY,
          imgWidth,
          imgHeight,
        );
        heightRemaining -= pageContentHeight;
        currentY += pageContentHeight;
        if (heightRemaining > 0) {
          pdf.addPage();
          position = margin;
        }
      }
    }

    pdf.save(filename);
  } finally {
    if (wasDark) document.documentElement.classList.add('dark');
  }
}
